import React, { Component } from 'react'
import closeIcon from '../../assets/icons/close-dark.svg'
import { Context } from '../Context'
export default class SideMenuInfo extends Component {
    static contextType = Context

    render() {
        const activeReferenceItem = this.context.state.activeReferenceItem
        if (!activeReferenceItem) return null

        return (
            <div className={this.props.className}>
                <div style={{ minHeight: '300px' }}>
                    <div onClick={() => this.context.updateState({ infoMenu: false })} style={componentStyle.mainMenuCloseButton}>
                        <img style={{ width: '112px', height: '112px' }} src={closeIcon} />
                    </div>
                    <div style={componentStyle.header1Container}>
                        <span style={componentStyle.header1}>{activeReferenceItem.typeTitle}</span>
                    </div>
                    <div style={componentStyle.houseTypeContainer}>
                        <div>
                            <span style={componentStyle.houseHeader1}>{activeReferenceItem.title}</span>
                        </div>
                        <div style={componentStyle.houseHeader2Container}>
                            <span style={componentStyle.houseHeader2}>{activeReferenceItem.category}</span>
                        </div>
                    </div>

                    <div style={componentStyle.houseSpecsContainer}>
                        <div style={componentStyle.houseSpecsContainerInner}>
                            <div style={componentStyle.houseSpecsTextContainer}>
                                <div className="row">
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsKeyText}>Projekt</span>
                                    </div>
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.type}</span>
                                    </div>
                                </div>
                            </div>
                            <div style={componentStyle.houseSpecsTextContainer}>
                                <div className="row">
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsKeyText}>Ort</span>
                                    </div>
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.location}</span>
                                    </div>
                                </div>
                            </div>
                            <div style={componentStyle.houseSpecsTextContainer}>
                                <div className="row">
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsKeyText}>Bauzeit</span>
                                    </div>
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.duration}</span>
                                    </div>
                                </div>
                            </div>
                            <div style={componentStyle.houseSpecsTextContainer}>
                                <div className="row">
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsKeyText}>Kategorie</span>
                                    </div>
                                    <div className="col-6">
                                        <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.category}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div style={componentStyle.houseSpecsContainerInner}>
                            <div style={{flex: 1, flexDirection: 'column'}}>
                                <div style={componentStyle.houseSpecsTextContainer}>
                                    <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.type}</span>
                                </div>
                                <div style={componentStyle.houseSpecsTextContainer}>
                                    <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.location}</span>
                                </div>
                                <div style={componentStyle.houseSpecsTextContainer}>
                                    <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.duration}</span>
                                </div>
                                <div style={componentStyle.houseSpecsTextContainer}>
                                    <span style={componentStyle.houseSpecsValueText}>{activeReferenceItem.category}</span>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div style={{ marginTop: 40, marginLeft: 50 }}>
                        <div>
                            <span style={componentStyle.houseSpecsKeyText}>{activeReferenceItem.details[0].header}</span>
                        </div>
                        <ul style={{ paddingRight: 25 }}>
                            {activeReferenceItem.details[0].content.map(content => {
                                return <li style={componentStyle.houseSpecsValueText}>{content}</li>
                            })}
                        </ul>
                    </div>
                    {activeReferenceItem.details[1] && (
                        <div style={{ marginTop: 40, marginLeft: 50 }}>
                            <div>
                                <span style={componentStyle.houseSpecsKeyText}>{activeReferenceItem.details[1].header}</span>
                            </div>
                            <ul style={{ paddingRight: 25 }}>
                                {activeReferenceItem.details[1].content.map(content => {
                                    return <li style={componentStyle.houseSpecsValueText}>{content}</li>
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const componentStyle = {
    mainMenuCloseButton: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    header1Container: {
        marginTop: 40,
        marginLeft: 50,
    },
    header1: {
        fontSize: 36,
        fontWeight: '800',
        color: '#323F4D',
    },
    houseTypeContainer: {
        marginTop: 80,
        marginLeft: 50,
    },
    houseHeader1: {
        color: 'red',
        fontSize: 36,
        fontWeight: '800',
    },
    houseHeader2Container: {
        marginTop: 10,
    },
    houseHeader2: {
        color: '#323F4D',
        fontSize: 30,
    },
    houseSpecsContainer: {
        borderTop: '4px dashed #707070',
        borderBottom: '4px dashed #707070',
        marginLeft: 50,
        marginRight: 50,
        marginTop: 100,
        display: 'flex',
        flexDirection: 'row',
    },
    houseSpecsContainerInner: {
        flex: 1,
        flexDirection: 'column',
        marginTop: 30,
        marginBottom: 30,
    },
    houseSpecsTextContainer: {
        padding: 7,
    },
    houseSpecsKeyText: {
        color: '#323F4D',
        fontSize: 28,
        fontWeight: '600',
    },
    houseSpecsValueText: {
        color: '#323F4D',
        fontSize: 28,
    },
    houseExplainHeader: {
        color: '#323F4D',
        fontSize: 28,
        fontWeight: '600',
    },
    houseExplainText: {
        color: '#323F4D',
        fontSize: 28,
    },
}
